/**
 * Dimensionnement des visuels TMDB.
 *
 * Le catalogue stocke les fonds en `/t/p/original/` : ce sont des fichiers
 * 3840 × 2160 de plusieurs mégaoctets, servis tels quels au hero — y compris
 * sur un téléphone en 4G. Ces aides réécrivent le segment de taille de l'URL
 * et produisent un `srcSet`, pour que le navigateur télécharge la variante
 * qui correspond réellement à la place occupée à l'écran.
 */

const TMDB = /^(https?:\/\/image\.tmdb\.org\/t\/p\/)([^/]+)(\/.+)$/;

/** Réécrit une URL TMDB vers une largeur donnée. Laisse tout le reste intact. */
export function sized(url, size) {
  if (!url) return url;
  const parts = TMDB.exec(url);
  return parts ? `${parts[1]}${size}${parts[3]}` : url;
}

const buildSet = (url, widths) => {
  const parts = TMDB.exec(url || '');
  if (!parts) return undefined;
  return widths.map((w) => `${parts[1]}w${w}${parts[3]} ${w}w`).join(', ');
};

/* ── Affiches (ratio 2:3) ──────────────────────────────────────── */
export const posterSrc = (url) => sized(url, 'w342');
export const posterSet = (url) => buildSet(url, [185, 342, 500]);
/** Une affiche fait au plus ~220 px de large, doublée sur écran dense. */
export const POSTER_SIZES = '(min-width: 1280px) 200px, (min-width: 640px) 170px, 44vw';

/* ── Fonds (ratio 16:9) ────────────────────────────────────────── */
export const backdropSrc = (url) => sized(url, 'w1280');
export const backdropSet = (url) => buildSet(url, [780, 1280, 1920]);
export const BACKDROP_SIZES = '100vw';

/* ── Vignettes paysage (épisodes, reprise de lecture) ──────────── */
export const stillSrc = (url) => sized(url, 'w500');
export const stillSet = (url) => buildSet(url, [300, 500, 780]);
export const STILL_SIZES = '(min-width: 640px) 340px, 62vw';
